import {usePageLanguage} from './usePageLanguage';

/**
 * Country Instance of the page e.g. like global de, fr, jp
 */
export function usePageCountry() {
  const language = usePageLanguage();
  const country = navigator.language.split('-')[1];
  return country ?? language;
}